import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  headerConatiner: {
    boxShadow: `-7px 2px 13px rgba(0, 0, 0, 0.10)`,
    backgroundColor: theme.palette.neutralLighterAlt,
  },
}));
